import React from 'react';
import { List, Datagrid, TextField, DateField, TextInput, Filter, SelectInput } from 'react-admin';
import { CustomPagination, BulkDeleteButtonAdmin } from './utils';

const TotalMismatchFilter = props => (
    <Filter {...props}>
        <SelectInput
            label="Поле"
            source="field"
            choices={[
                { id: 'sno', name: 'Станция' },
                { id: 'location_id', name: 'Локация' },
                { id: 'created', name: 'Время создания' },
                { id: 'updated', name: 'Последнее обновление' },
            ]}
            alwaysOn
        />
        <TextInput
            label="Поиск"
            source="q"
            alwaysOn
        />
    </Filter>
);

export const TotalMismatchList = ({ permissions, ...props }) => (
    <List
        {...props}
        filters={<TotalMismatchFilter />}
        bulkActionButtons={<BulkDeleteButtonAdmin permissions={permissions} />}
        pagination={<CustomPagination />}
    >
        <Datagrid rowClick="edit">
            <TextField
                label="Станция"
                source="sno"
            />
            <TextField
                label="Локация"
                source="location_id"
            />
            <DateField
                label="Время создания"
                source="created"
                showTime
                locales="ru-RU"
            />
            <DateField
                label="Последнее обновление"
                source="updated"
                showTime
                locales="ru-RU"
            />
        </Datagrid>
    </List>
);
